<dx-popup
  *ngIf="popupOpen"
  (onShowing)="initForm()"
  (visibleChange)="popupOpenChange.emit($event);"
  [(visible)]="popupOpen"
  [dragEnabled]="false"
  [enableBodyScroll]="true"
  [fullScreen]="appService.isSmallScreen()"
  [height]="'70vh'"
  [showCloseButton]="true"
  title="{{ 'WIDGETS.NAMES.THREE_DIM_MODEL' | translate}}">
  <div #formContainer class="sideBySideLists">
    <div *ngIf="!!modelToEdit" class="flexColumn flexFill" style="overflow: hidden; width: 100%; height: auto">
      <div class="flexRow" *ngIf="localBlob">
        <dx-text-box [(value)]="modelToEdit.fileName" class="flexFill"
                     placeholder="{{ 'WIDGETS.THREE_DIM.NAME' | translate }}"
                     valueChangeEvent="keyup">
          <dx-validator>
            <dxi-validation-rule type="required"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
        <dx-button (onClick)="loadFile()" hint="{{ 'WIDGETS.THREE_DIM.SELECT_FILE' | translate }}" stylingMode="text"
                   type="default">
          <i class="vr-ic_fluent_folder_open_24_regular"></i>
        </dx-button>
      </div>
      <div *ngIf="popupOpen" [style.min-height]="appService.isSmallScreen()? '50vh' : ''"
           class="flexColumn flexFill dx-card flat"
           style="position: relative; overflow: hidden;">

        <div [style.opacity]="!!modelToEdit.fileName? 0 : 100" [style.z-index]="!!modelToEdit.fileName? 0 : 1"
             class="threeDimPlaceHolder">
          <span>{{ "WIDGETS.THREE_DIM.NO_FILE" | translate }}</span>
          <dx-button
            (onClick)="loadFile()"
            [elementAttr]="{class:'outlinedRedButton'}"
            [height]="36"
            [type]="'default'"
            [width]="175"
            class="raised-button"
            hint="{{'WIDGETS.THREE_DIM.SELECT_FILE' | translate}}">
            <i class="vr-ic_fluent_folder_open_24_regular"></i>
            <span>{{ 'WIDGETS.THREE_DIM.SELECT_FILE' | translate }}</span>
          </dx-button>
        </div>
        <ng-container [style.opacity]="!!modelToEdit.fileName? 100 : 0">
          <app-three-dim-viewer
            #threeDimViewerComponent
            (deleteMeasure)="deleteMeasure($event.measureId, $event.mesh)"
            (loadingWorkflowStatus)="loadingWorkflowStatus = $event"
            (selectedMeshInstanceId)="selectedMesh = $event; measurePanelIsSelected = false; getSelectedItems()"
            [keyMeshesList]="metricsMap"
            [(localBlob)]="localBlob"
            [theThreeDimModel]="modelToEdit"
            class="flexFill">
          </app-three-dim-viewer>

          <div (click)="measurePanelIsSelected = true; threeDimViewerComponent.deselectMesh(); getSelectedItems()"
               [ngClass]="measurePanelIsSelected? 'selectedPanel' : ''"
               [style.background-color]="getStylizedCSSVariable('--dx-color-main-bg').concat('90')"
               [style.opacity]="loadingWorkflowStatus === FileLoadingWorkflowEnum.COMPLETED? 1 : 0"
               class="measurePanel">
            <span class="measurePanelTitle">{{ "WIDGETS.THREE_DIM.MEASURE_PANEL" | translate }}</span>
            <dx-scroll-view direction="vertical">
              <dx-sortable (onReorder)="reorderPanelMetrics($event)" [allowReordering]="true" [handle]="'#movingHandle'"
                           class="measurePanelMeasures">
                <div *ngFor="let measure of measurePanelMetrics" class="flexRow">
                  <i class="vr-ic_fluent_re_order_dots_vertical_24_regular movingHandle" id="movingHandle"></i>
                  <span>{{ measure.partitionName }} > {{ measure.deviceName }} > {{ measure.name }}
                    : <b>{{ appService.getParsedMetricValue(measure) }}</b> {{ measure.dataUnit }}</span>
                  <dx-button
                    (onClick)="deleteMeasure(measure.id,-1)"
                    [stylingMode]="'text'"
                    class="smallButton"
                    style="margin-left: 5px;">
                    <i class="vr-ic_fluent_delete_24_regular"></i>
                  </dx-button>
                </div>
                <span
                  *ngIf="!measurePanelMetrics || measurePanelMetrics.length === 0">{{ 'COMMON.NO_DATA_INSERTED' | translate }}</span>
              </dx-sortable>
            </dx-scroll-view>
          </div>
        </ng-container>
      </div>
    </div>

    <ng-container *ngIf="(selectedMesh !== null && selectedMesh !== undefined) || measurePanelIsSelected">
      <div class="flexFill flexColumn" style="overflow: hidden; width: 100%">
        <app-partition-selector
          [(selectedPartition)]="dashboardService.selectedPartitionIds[0]">
        </app-partition-selector>
        <div [ngClass]="appService.isSmallScreen()? 'flexColumn' : 'flexRow'" class="flexFill"
             style="overflow: hidden;">
          <app-device-selector
            #deviceSelectorComponent
            (selectedDeviceIdChange)="getMetricIds()"
            [(selectedDeviceId)]="dashboardService.selectedDeviceIds[0]"
            [selectedPartitionId]="dashboardService.selectedPartitionIds[0]"
            [style.width.%]="appService.isSmallScreen()? 100 : 50"
            style="height: 100%; display: flex; flex-direction: column; overflow: hidden">
          </app-device-selector>
          <app-metric-selector
            (listSelectionChanged)="applySelection($event)"
            [deviceList]="deviceSelectorComponent.deviceList"
            [inputDisplayMode]="'list'"
            [metricList]="metricList"
            [selectedDeviceId]="dashboardService.selectedDeviceIds[0]"
            [selectedMetricIds]="selectedMetricIds"
            [selectedPartitionId]="dashboardService.selectedPartitionIds[0]"
            [style.width.%]="appService.isSmallScreen()? 100 : 50"
            style="height: 100%; display: flex; flex-direction: column; overflow: hidden">
          </app-metric-selector>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="(selectedMesh === null || selectedMesh === undefined) && !measurePanelIsSelected && localBlob">
      <div class="flexFill flexColumn dx-card flat" style="overflow: hidden; width: 100%; justify-content: center">
        <div class="selectMeshPlaceholder">
          <span>{{ "WIDGETS.THREE_DIM.NO_MESH" | translate }}</span>
        </div>
      </div>
    </ng-container>
  </div>


<dx-load-panel
  *ngIf="uploadStage > 0"
  [container]="formContainer"
  [visible]="true">
  <dxo-position
    [of]="formContainer"
    at="center"
    my="center">
  </dxo-position>
</dx-load-panel>

  <dxi-toolbar-item
    cssClass="fullWidthSearchBar"
    location="before"
    toolbar="bottom">
    <div *dxTemplate>
      <dx-progress-bar *ngIf="uploadStage > 0" [max]="100" [showStatus]="false" [value]="uploadPerc"
                       [width]="'100%'"></dx-progress-bar>
    </div>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    [disabled]="!!modelToEdit && (!modelToEdit.file || (fileChanged && uploadStage > 0) || !modelToEdit.fileName)"
    location="before"
    toolbar="bottom"
    widget="dxButton">
    <dxo-options
      [icon]="'save'"
      [onClick]="saveCard"
      [text]="translate.instant('BUTTONS.SAVE')"
      [type]="'default'"
      stylingMode="contained">
    </dxo-options>
  </dxi-toolbar-item>
</dx-popup>
